module.exports = __webpack_public_path__ + "static/media/send-live.fec228ca.svg";